import { render, staticRenderFns } from "./AirticketgaiqiantuipiaoRight.vue?vue&type=template&id=2f96abe4&scoped=true"
import script from "./AirticketgaiqiantuipiaoRight.vue?vue&type=script&lang=js"
export * from "./AirticketgaiqiantuipiaoRight.vue?vue&type=script&lang=js"
import style0 from "./AirticketgaiqiantuipiaoRight.vue?vue&type=style&index=0&id=2f96abe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96abe4",
  null
  
)

export default component.exports